import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataApi } from 'app/Model/dataApi';
import { DataApiService } from 'app/services/data-api.service';
import { ToastrServiceLocal } from 'app/services/toast/toastr.service';
import { MensajesHttpService } from 'app/utils/mensajesHttp/mensajes-http.service';
import { BehaviorSubject, EMPTY, Observable, Subject, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import {DatosGenerales, EgresadoInterface} from 'app/Model/Oferta Academica/OfertaAcademica'

@Injectable({
  providedIn: 'root'
})
export class FichaAdmisionFacadeService {
  private Action$ = new Subject<any>();
  public responseAction$: Observable<any> = this.Action$.asObservable();

  private Cargando$ = new BehaviorSubject<boolean>(false);
  public responseCargando$: Observable<boolean> = this.Cargando$.asObservable();

  private Error$ = new BehaviorSubject<any>({ hasError: true, recurso: '', messageError: '', errors: [] });
  public responseError$: Observable<any> = this.Error$.asObservable();

  private DatosGenerales$ = new BehaviorSubject<DatosGenerales[]>([]);
  public responseDatosGenerales$: Observable<DatosGenerales[]> = this.DatosGenerales$.asObservable();

  private Egresado$ = new BehaviorSubject<EgresadoInterface[]>([]);
  public responseEgresado$: Observable<EgresadoInterface[]>= this.Egresado$.asObservable();

  private PostulacionRequisitos$ = new BehaviorSubject<any>({ requierePostulacion: false, idProcesoCarrera: null, nombreProceso: null, requisitos: [], detalles: [] });
  public responsePostulacionRequisitos$: Observable<any> = this.PostulacionRequisitos$.asObservable();


  constructor(
    public _toast: ToastrServiceLocal, 
    public _dataApi: DataApiService,
    public _mensajesHttp: MensajesHttpService
  ) { }

  mostrarDatosGenerales(params: any){

    this.Cargando$.next(true);
    const request$ = this._dataApi.GetDataApi(`solicitudes/generales`, params).pipe(
      tap((result: DataApi | any) => {
        this.DatosGenerales$.next(result.data);
        this.Cargando$.next(false);
      }),
      catchError((error: HttpErrorResponse) => {
        console.log(error)
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un erro al mostrar los datos generales', '');
        this.Cargando$.next(false);
        this.Error$.next({ hasError: true, recurso: 'POST', messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrio un erro al mostrar la Solicitud Promocion'), errors: [] });
        return EMPTY;
      })
    );

    return request$.subscribe();
  }

  mostrarEgresado(params: any){

    this.Cargando$.next(true);
    const request$ = this._dataApi.GetDataApi(`solicitudes/egresado`, params).pipe(
      tap((result: DataApi | any) => {
        this.Egresado$.next(result.data);
        this.Cargando$.next(false);
      }),
      catchError((error: HttpErrorResponse) => {
        console.log(error)
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un erro al mostrar los datos generales', '');
        this.Cargando$.next(false);
        this.Error$.next({ hasError: true, recurso: 'POST', messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrio un erro al mostrar la Solicitud Promocion'), errors: [] });
        return EMPTY;
      })
    );

    return request$.subscribe();
  }

  guardarSolicitud(params: any) {
    this.Action$.next({});
    this.Cargando$.next(true);
    this._toast.mensajeLoading('Cargando', 'Procesando la información');

    const request$ = this._dataApi.PostDataApi(`solicitudes`, params).pipe(
      tap((result: DataApi | any) => {
        // console.log(result)
        this._toast.clearToasts();
        this._toast.mensajeSuccess(`${result?.data?.Table0[0]?.descripcion || ''}`,'')
        this.Cargando$.next(false);
        this.Action$.next(result);
      }),
      catchError((error: HttpErrorResponse) => {
        console.log(error)

        this._toast.clearToasts();
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al guardar la solicitud', '');
        this.Cargando$.next(false);
        return EMPTY;
      })
    );
    return request$.subscribe();
  }

  // Se llama UNA sola vez, justo después de crear la solicitud, para generar
  // los renglones de seguimiento de requisitos antes del primer Listar.
  generarRequisitosPostulacion(idSolicitud: any): Observable<any> {
    this.Cargando$.next(true);
    return this._dataApi.PostDataApi(`solicitudes/postulacion/requisitos/generar`, { idSolicitud }).pipe(
      tap(() => this.Cargando$.next(false)),
      catchError((error: HttpErrorResponse) => {
        console.log(error)
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrió un error al generar los requisitos de postulación', '');
        this.Cargando$.next(false);
        this.Error$.next({ hasError: true, recurso: 'POST', messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrió un error al generar los requisitos de postulación'), errors: [] });
        return of(null);
      })
    );
  }

  // Devuelve el Observable (no se auto-suscribe) para que quien lo llame reciba
  // el valor FRESCO de esta petición puntual, en vez de depender del valor
  // que ya traiga cacheado responsePostulacionRequisitos$ (BehaviorSubject).
  mostrarRequisitosPostulacion(idSolicitud: any, params: any): Observable<any> {
    this.Cargando$.next(true);
    return this._dataApi.GetDataApi(`solicitudes/postulacion/requisitos/${idSolicitud}`, params).pipe(
      map((result: DataApi | any) => {
        let postulacion = { requierePostulacion: false, idProcesoCarrera: null, nombreProceso: null, fechaInicio: null, fechaFin: null, requisitos: [], detalles: [] };

        if (result.hasError === false) {
          const cabecera = result.data.Table0?.[0] || {};
          postulacion = {
            requierePostulacion: !!cabecera.requierePostulacion,
            idProcesoCarrera: cabecera.idProcesoCarrera ?? null,
            nombreProceso: cabecera.nombreProceso ?? null,
            fechaInicio: cabecera.fechaInicio ?? null,
            fechaFin: cabecera.fechaFin ?? null,
            requisitos: result.data.Table1 || [],
            detalles: result.data.Table2 || [],
          };
        }

        this.PostulacionRequisitos$.next(postulacion);
        this.Cargando$.next(false);
        return postulacion;
      }),
      catchError((error: HttpErrorResponse) => {
        console.log(error)
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrió un error al mostrar los requisitos de postulación', '');
        this.Cargando$.next(false);
        this.Error$.next({ hasError: true, recurso: 'GET', messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrió un error al mostrar los requisitos de postulación'), errors: [] });
        return of({ requierePostulacion: false, idProcesoCarrera: null, nombreProceso: null, fechaInicio: null, fechaFin: null, requisitos: [], detalles: [] });
      })
    );
  }

  // Paso 1 de la subida directa a S3: pide la URL pre-firmada de subida (PUT).
  obtenerUrlPresignadaRequisito(params: { fileName: string; contentType: string; folder: string }): Observable<any> {
    this.Action$.next({});
    this.Cargando$.next(true);
    this._toast.mensajeLoading('Cargando', 'Procesando la información');

    return this._dataApi.PostDataApi(`uploads/presigned-url`, params).pipe(
      tap((result: any) => {
        this._toast.clearToasts();
        this.Cargando$.next(false);
        this.Action$.next(result);
      }),
      catchError((error: HttpErrorResponse) => {
        const errorBackend = error.error?.errors?.[0];
        const mensajeError = errorBackend?.descripcion ||
          this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrió un error al iniciar la subida del archivo');
        this._toast.clearToasts();
        this.Cargando$.next(false);
        this._toast.mensajeError('', mensajeError);
        return of(null);
      })
    );
  }

  // Paso 3 de la subida directa a S3: confirma que el archivo llegó al bucket
  // (el paso 2, el PUT directo a la URL pre-firmada, no pasa por el back).
  confirmarSubidaS3Requisito(key: string): Observable<any> {
    this.Action$.next({});
    this.Cargando$.next(true);
    this._toast.mensajeLoading('Cargando', 'Procesando la información');

    return this._dataApi.PostDataApi(`uploads/confirm`, { key }).pipe(
      tap((result: any) => {
        this._toast.clearToasts();
        this.Cargando$.next(false);
        this.Action$.next(result);
      }),
      catchError((error: HttpErrorResponse) => {
        const errorBackend = error.error?.errors?.[0];
        const mensajeError = errorBackend?.descripcion ||
          this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrió un error al confirmar la subida del archivo');
        this._toast.clearToasts();
        this.Cargando$.next(false);
        this._toast.mensajeError('', mensajeError);
        return of(null);
      })
    );
  }

  // El bucket es privado: rutaDocumento solo guarda la key de S3, así que para
  // ver/descargar el archivo hay que pedir una URL firmada fresca cada vez.
  descargarDocumentoRequisito(key: string): Observable<any> {
    this.Action$.next({});
    this.Cargando$.next(true);
    this._toast.mensajeLoading('Cargando', 'Procesando la información');

    return this._dataApi.GetDataApi(`solicitudes/postulacion/requisitos/documento/descargar/${key}`, '').pipe(
      map((result: DataApi | any) => {
        this._toast.clearToasts();
        this.Cargando$.next(false);
        return result?.data?.[0]?.url || null;
      }),
      catchError((error: HttpErrorResponse) => {
        this._toast.clearToasts();
        this.Cargando$.next(false);
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrió un error al abrir el documento', '');
        return of(null);
      })
    );
  }

  subirDocumentoRequisitoPostulacion(params: any): Observable<any> {
    this.Action$.next({});
    this.Cargando$.next(true);
    this._toast.mensajeLoading('Cargando', 'Procesando la información');

    return this._dataApi.PostDataApi(`solicitudes/postulacion/requisitos/documento`, params).pipe(
      tap((result: any) => {
        this._toast.clearToasts();
        this.Cargando$.next(false);
        this.Action$.next(result);
      }),
      catchError((error: HttpErrorResponse) => {
        const errorBackend = error.error?.errors?.[0];
        const mensajeError = errorBackend?.descripcion ||
          this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrió un error al guardar el documento');
        this._toast.clearToasts();
        this.Cargando$.next(false);
        this._toast.mensajeError('', mensajeError);
        return EMPTY;
      })
    );
  }

  eliminarDocumentoRequisitoPostulacion(params: any): Observable<any> {
    this.Action$.next({});
    this.Cargando$.next(true);
    this._toast.mensajeLoading('Cargando', 'Procesando la información');

    return this._dataApi.PostDataApi(`solicitudes/postulacion/requisitos/documento/eliminar`, params).pipe(
      tap((result: any) => {
        this._toast.clearToasts();
        this.Cargando$.next(false);
        this.Action$.next(result);
      }),
      catchError((error: HttpErrorResponse) => {
        const errorBackend = error.error?.errors?.[0];
        const mensajeError = errorBackend?.descripcion ||
          this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrió un error al eliminar el documento');
        this._toast.clearToasts();
        this.Cargando$.next(false);
        this._toast.mensajeError('', mensajeError);
        return EMPTY;
      })
    );
  }

  VerOrientaciones(idCarrera: any,idpromocion: any){
    this.Cargando$.next(true);
    const request$ = this._dataApi.GetDataApi(`solicitudes/orientaciones/planEstudio/${idCarrera}/${idpromocion}`,'').pipe(
      tap((result: DataApi | any) => {
         this.Cargando$.next(false);
      }),
      catchError((error: HttpErrorResponse) => {
        console.log(error)
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un erro al mostrar orientaciones', '');
        this.Cargando$.next(false);
        this.Error$.next({ hasError: true, recurso: 'POST', messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrio un erro al mostrar las promociones'), errors: [] });
        return EMPTY;
      })
    );
  
    return request$;  
  }



}

